// extracted by mini-css-extract-plugin
export default {"window":"ShowReservationWindow_window__2cvqd"};